<template>
    <div class="task-container" style="margin-bottom:10px;">
         <div class="part-bottom">
                <div class="filter">
                    <el-form :inline="true" :model="filter">

                        <el-form-item label="任务来源:">
                            <el-select v-model="filter.taskSourceType" @change="searchHandle" filterable clearable placeholder="请选择任务来源"
                                       size="small">
                                <el-option v-for="item in taskSource" :label="item.label" :value="item.value"
                                           :key="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="任务ID:">
                            <el-input size="small" placeholder="请输入任务ID" @change="searchHandle" v-model="filter.taskId" clearable
                                      maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="随访疾病:">
                            <el-select v-model="filter.diseaseId" @change="searchHandle" filterable clearable placeholder="请选择随访疾病"
                                       size="small">
                                <el-option v-for="item in diseaseList" :label="item.diseaseName" :value="item.id"
                                           :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="任务名称:">
                            <el-input placeholder="请输入随访任务名称" v-model="filter.title" @change="searchHandle" clearable size="small"
                                      maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchHandle" size="small">查询</el-button>
                            <el-button type="primary" @click="resetHandle" size="small">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="pagination">
                    <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :page-count="totalPage"
                            :current-page="currentPage"
                            @current-change="current_change"
                            :hide-on-single-page="true"
                    ></el-pagination>
                </div>
            </div>
        <el-table :data="tableData" height="700" border style="width: 100%" :header-cell-style="rowStyle" cell-style="rowStyle1">
            <el-table-column prop="id" label="ID" width="70"></el-table-column>
            <el-table-column prop="title" label="任务名称" width="200"> </el-table-column>
            <el-table-column prop="diseaseName" label="随访疾病" ></el-table-column>
            <!--<el-table-column prop="taskTags" label="优先级"></el-table-column>-->
            <el-table-column prop="finishNum" label="已随访"> </el-table-column>
            <el-table-column prop="waitNum" label="待随访"> </el-table-column>
            <el-table-column prop="thisMonthCallAvg" label="本月平均时长">
                <template slot-scope="scope">
                    <span>{{scope.row.thisMonthCall |avgFollowTime(scope.row.thisMonthFinish)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="allFinish" label="累积完成"> </el-table-column>
            <el-table-column prop="allCall" label="累积呼叫"> </el-table-column>
            <el-table-column prop="lostNum" label="失访人数"> </el-table-column>
            <el-table-column prop="lostRate" label="失访率"> </el-table-column>
            <el-table-column prop="passRate" label="合格率"> </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button  size="mini" style="font-size: 15px" @click="studyHandler(scope.row)" type="text"  >学习</el-button>
                </template>
            </el-table-column>
  </el-table>

    </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapMutations, mapState } from "vuex";
import { RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList,RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId } from "@src/assets/js/api.js";
export default {
  name: "task-container",
  data() {
    return {
      totalPage: 1,
      currentPage: 1,
      tableData:[],
      filter: {
        taskSourceType: "",
        diseaseId: "",
        taskType: 1, // 默认 进行中 的任务
        title: "",
        taskId:""
      },
    };
  },
  props: {
    diseaseList:{
       type: Array,
    },
    taskSource:{
       type: Array,
    },
    taskInfo: {
      type: Object,
      default() {
        return {

        };
      },
    },
  },
  computed: {
    ...mapGetters(["userid", "questionId"]),
  },
  components: {},
  filters: {
    formatTime: function(value) {
      if (!value) return "0分钟";
      if (value > 60) {
        return parseInt(value / 60) + "分" + (value % 60) + "秒";
      } else {
        return value + "秒";
      }
    },
    lostNumRate: function(value, power) {
      var Times = 0.0;
      if (power != 0) {
        Times = ((value / power) * 100).toFixed(2);
      }
      return Times;
    },
    formatTags: function(value, power) {
      var taskTags = [
        { label: "急", value: 1, power: 1, showPower: false },
        {
          label: "V",
          value: 2,
          power: 1,
          showPower: false,
        },
        { label: "重", value: 3, power: 1, showPower: false },
        {
          label: "密",
          value: 4,
          power: 1,
          showPower: false,
        },
        { label: "合", value: 5, power: 1, showPower: false },
        {
          label: "单",
          value: 6,
          power: 1,
          showPower: false,
        },
        { label: "难", value: 7, power: 1, showPower: false },
        {
          label: "免",
          value: 8,
          power: 1,
          showPower: false,
        },
      ];
      var str = ["+", "++", "+++"];
      var result = [];
      power = String(power);
      if (value) {
        value = String(value);
        for (var i = 0; i < value.length; i++) {
          var item = value[i];
          var p = power[i] > 3 ? 3 : power[i];
          var tag = taskTags.find((v, i) => {
            return v.value == item;
          });
          var rs = tag.label + str[p - 1];
          if (result.length == 0) {
            result.push(rs);
          } else {
            if (!rs.length < result[0].length) {
              result.unshift(rs);
            } else {
              result.push(rs);
            }
          }
        }
        return result.join(";");
      } else {
        return "暂无";
      }
    },
    formatfollowUpWay: function(value) {
      var text = "";
      switch (value) {
        case 11:
          text = "线上+电话";
          break;
        case 12:
          text = "电话";
          break;
        case 21:
          text = "线上";
          break;
        default:
          text = "未知";
          break;
      }
      return text;
    },
    formatSourceType: function(value) {
      var text = "";
      switch (value) {
        case 1:
          text = "医院";
          break;
        case 2:
          text = "公司";
          break;
        case 3:
          text = "荟医";
          break;
        default:
          text = "其他";
          break;
      }
      return text;
    },
    avgFollowTime: function(value, power) {
      var Times = 0.0;
      if (power != 0) {
        Times = (value / power).toFixed(2);
      }
      if (Times > 60) {
        return parseInt(Times / 60) + "分钟" + (Times % 60).toFixed(2) + "秒";
      } else {
        return Times + "秒";
      }
    },
  },
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskType", "setQuestion"]),
      rowStyle({row,rowIndex}){
          if (rowIndex == 0) {
              return 'color:#000;background:rgba(136, 136 ,136,0.25);border-color:rgb(230,230,230);cursor:pointer;font-size:17px'
          }
      },  rowStyle1({row,rowIndex}){
          return 'color:#000;font-size:15px'

      },
    searchHandle() {
      this.currentPage = 1
      this.getTableList();
    },
    resetHandle() {
      this.filter.taskSourceType = "";
      this.filter.diseaseId = "";
      this.filter.title = "";
      this.filter.taskId = "";
      this.searchHandle()
    },
    // 分页 交互
    current_change(currentPage) {
      this.currentPage = currentPage;
      this.getTableList({
        pageSize: currentPage,
      });
    },
     getTableList() {
      this.tableLoading = true;
      this.getTableListAsync()
        .then((result) => {
          this.tableLoading = false;
          if (_.isArray(result)) {
            this.tableData.splice(0, this.tableData.length);
            _.each(result, (item) => {
              this.tableData.push(item);
            });
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
   studyHandler(taskInfo) {
      this.getFollowupTaskQuestionnaireNewId(taskInfo.id).then((res) => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
        }
      });
       let query = `taskId=${taskInfo.id}&followUpWay=${taskInfo.followUpWay}`;
      this.$router.push("/waitStudy?" + query);
    },
    async getFollowupTaskQuestionnaireNewId(id) {
      let request = new RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId();
      request.p_followupTaskId = id;
      await request.send();
      return request.result;
    },

    async getTableListAsync() {
      let data = new RestNewFollowupCallCenterServiceGetQueryQFollowUpTaskList();
      data.p_userId = this.userid;
      data.p_status = this.filter.taskType;
      data.p_diseaseId = this.filter.diseaseId || null;
      data.p_taskId = this.filter.taskId;
      data.p_taskSourceType = this.filter.taskSourceType || null;
      data.p_pageIndex = this.currentPage;
      data.p_pageSize = 10;
      if (this.filter.title && this.filter.title.trim().length > 0) {
        data.p_title = this.filter.title;
      }
      await data.send();
      this.totalPage = data.result.totalPage;
      this.currentPage = data.result.page;
      if (data.result.status == 0) {
        return data.result.retValue;
      } else {
        this.errorHandle(data.result.retValue);
      }
    },
  },
  created() {},
  mounted(){
    this.getTableList()
  },
};
</script>

<style scoped lang="scss">
.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16),
    0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;
}

.task-container {
  .singTask {
    width: 96%;
    margin: 0 auto;
  }
  .taskTitle {
    color: rgba(16, 16, 16, 100);
    font-size: 16px;
    border: 1px solid rgba(187, 187, 187, 0.5);
    border-bottom: 0;
    padding-left: 16px;
    height: 48px;
    line-height: 48px;
    display: flex;
    justify-content: flex-start;
    .label {
      color: rgba(191, 191, 191, 100);
      font-size: 16px;
      text-align: left;
      margin-right: 10px;
    }
    .value {
      color: rgba(54, 147, 255, 100);
      font-size: 16px;
      text-align: left;
    }
  }
  .taskInfo {
    width: 90%;
    display: flex;
    border-bottom: 1px solid rgba(187, 187, 187, 0.5);
    border-top: 1px solid rgba(187, 187, 187, 0.5);
    span {
      height: 48px;
      line-height: 48px;
      text-align: center;
      width: 10%;
      border-right: 1px solid rgba(187, 187, 187, 0.5);
      &:first-child {
        border-left: 1px solid rgba(187, 187, 187, 0.5);
      }
    }
  }
}
</style>
